import axios from '@utils/http'

export const state = {
  cached: [],
  cachedRevFields: [],
}

export const getters = {}

export const mutations = {
  CACHE_CDMS(state, cdms) {
    state.cached = cdms
  },
  CACHE_REV_FIELDS(state, fields) {
    state.cachedRevFields = fields
  },
}

export const actions = {
  uploadCdms({ commit, dispatch, getters }, { file }) {
    let formData = new FormData()

    formData.append('file', file)
    return axios
      .post('/api/cdms/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(response => {
        const data = response.data
        const cdms = data.cdms

        // TODO store organization data
        commit('CACHE_CDMS', cdms)
        return data
      })
  },

  uploadRevUsage({ commit, dispatch, getters }, { file }) {
    let formData = new FormData()

    formData.append('file', file)
    return axios.post('/api/cdms/uploadRev', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  getCdms({ commit, dispatch, getters }, { force, queryTerms } = {}) {
    if (!force && state.cached && state.cached.length > 0) {
      return Promise.resolve(state.cached)
    }

    return axios.get('/api/cdmFields').then(response => {
      const fields = response.data
      return axios.get('/api/cdms', { params: queryTerms }).then(response => {
        const cdms = response.data
        commit('CACHE_CDMS', cdms)
        return { fields, cdms }
      })
    })
  },

  getOnlyCdms({ commit, dispatch, getters }, { force, queryTerms } = {}) {
    if (!force && state.cached && state.cached.length > 0) {
      return Promise.resolve(state.cached)
    }

    return axios.get('/api/cdms', { params: queryTerms }).then(response => {
      const cdms = response.data.results
      commit('CACHE_CDMS', cdms)
      return { results: cdms, totalCount: response.data.totalCount }
    })
  },

  getCdm({ commit, dispatch, getters }, { cdmId } = {}) {
    return axios.get('/api/cdmFields').then(response => {
      const fields = response.data
      return axios.get(`/api/cdms/${cdmId}`).then(response => {
        const cdm = response.data
        return { cdm, fields }
      })
    })
  },

  getRevUsageFields({ commit, dispatch, getters }, { force } = {}) {
    if (!force && state.cachedRevFields && state.cachedRevFields.length > 0) {
      return Promise.resolve({ fields: state.cachedRevFields })
    }

    return axios.get('/api/revUsageFields').then(response => {
      const fields = response.data
      commit('CACHE_REV_FIELDS', fields)
      return { fields }
    })
  },

  getRevUsage({ commit, dispatch, getters }, { cdmId, queryTerms } = {}) {
    return axios
      .get(`/api/cdms/${cdmId}/revUsage`, { params: queryTerms })
      .then(response => {
        return {
          revUsage: response.data.results,
          totalCount: response.data.totalCount,
        }
      })
  },

  getInvalidCoding({ commit, dispatch, getters }, { cdmId } = {}) {
    return axios.get(`/api/cdms/${cdmId}/invalidCoding`).then(response => {
      return response.data
    })
  },
}
